/* build 2026-07-13T09 refresh */
/* Shared interactions — nav, scroll reveal, count-up, accordion, gallery, variants */
/* ---- Single source of truth for commerce data (audit W1.1) ----
   Every price/name/image on the site derives from this map. Egg = $35.94/6, konjac = $32.94/6. */
/* Shopify theme: layout/theme.liquid defines window.MNCatalog (real handles, asset_url images,
   and a per-pack Shopify variant-id map `v`) BEFORE this file loads. The literal below is the
   original static-site fallback, kept 1:1 for future diffing against the source. */
window.MNCatalog = window.MNCatalog || {
  'ew-spaghetti':   { name: 'Egg White Spaghetti',      fam: 'egg',    p6: 35.94, p12: 70.68, img: 'images/packs/ew-spaghetti-front-u.webp',   url: 'product.html?p=ew-spaghetti' },
  'ew-angelhair':   { name: 'Egg White Angel Hair',     fam: 'egg',    p6: 35.94, p12: 70.68, img: 'images/packs/ew-angelhair-front-u.webp',   url: 'product.html?p=ew-angelhair' },
  'rte-angelhair':  { name: 'Konjac Angel Hair',  fam: 'konjac', p6: 32.94, p12: 64.68, img: 'images/packs/rte-angelhair-front-org.webp',  url: 'product.html?p=rte-angelhair' },
  'rte-fettuccine': { name: 'Konjac Fettuccine',  fam: 'konjac', p6: 32.94, p12: 64.68, img: 'images/packs/rte-fettuccine-front-org.webp', url: 'product.html?p=rte-fettuccine' },
  'rte-spaghetti':  { name: 'Konjac Spaghetti',   fam: 'konjac', p6: 32.94, p12: 64.68, img: 'images/packs/rte-spaghetti-front-org.webp',  url: 'product.html?p=rte-spaghetti' },
  'rte-rice':       { name: 'Konjac Rice',             fam: 'konjac', p6: 32.94, p12: 64.68, img: 'images/packs/rte-rice-front-org.webp',       url: 'product.html?p=rte-rice' }
};
/* Resolve a cart line to canonical data from an id like "<slug>-6" / "<slug>-12" / "trio" */
window.MNResolve = function (id) {
  var m = String(id).match(/^(.+?)-(6|12)$/);
  var slug = m ? m[1] : String(id), packs = m ? m[2] : '6';
  var c = window.MNCatalog[slug];
  if (!c) return null;
  return { slug: slug, packs: packs, name: c.name, img: c.img, price: packs === '12' ? c.p12 : c.p6, fam: c.fam };
};
/* Map a cart-line id ("<slug>-6" / "<slug>-12" / "<slug>-24" …) to a Shopify variant id.
   The `v` map is injected per product by layout/theme.liquid from catalog-map.json. */
window.MNVariantId = function (id) {
  if (!id) return null;
  var m = String(id).match(/^(.+?)-(\d+)$/);
  var slug = m ? m[1] : String(id), pack = m ? m[2] : '6';
  var c = window.MNCatalog && window.MNCatalog[slug];
  if (c && c.v && c.v[pack]) return c.v[pack];
  return null;
};
/* Shopify AJAX Cart API base (locale-aware root when Shopify exposes it) */
window.MNCartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
(() => {
  const nav = document.querySelector('.nav');
  // sticky border state
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-stuck', window.scrollY > 12);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- MUD-style product menu overlay (opens from "Menu"; products only, other links below) ---- */
  (function () {
    if (!document.querySelector('[data-menu-open]')) return;
    var R = window.MNRoutes || {};
    var PRODUCTS = window.MNMenuProducts || [
      { name: 'Egg White Spaghetti', href: 'product.html?p=ew-spaghetti', img: 'images/packs/ew-spaghetti-front-u.webp', tint: '#c9a23e', fam: 'egg' },
      { name: 'Egg White Angel Hair', href: 'product.html?p=ew-angelhair', img: 'images/packs/ew-angelhair-front-u.webp', tint: '#c06a3c', fam: 'egg' },
      { name: 'Konjac Spaghetti', href: 'product.html?p=rte-spaghetti', img: 'images/packs/rte-spaghetti-front-org.webp', tint: '#3a7bb0', fam: 'konjac' },
      { name: 'Konjac Fettuccine', href: 'product.html?p=rte-fettuccine', img: 'images/packs/rte-fettuccine-front-org.webp', tint: '#b25069', fam: 'konjac' },
      { name: 'Konjac Angel Hair', href: 'product.html?p=rte-angelhair', img: 'images/packs/rte-angelhair-front-org.webp', tint: '#3f8a8f', fam: 'konjac' },
      { name: 'Konjac Rice', href: 'product.html?p=rte-rice', img: 'images/packs/rte-rice-front-org.webp', tint: '#c9a23e', fam: 'konjac' }
    ];
    var MTAG = { egg: 'Clean protein', konjac: 'Vegetable fiber' };
    var PTAG = { 'Egg White Spaghetti': '#1 Bestseller', 'Spicy Beef Ramen': 'New' };
    var tiles = PRODUCTS.map(function (p) {
      return '<a class="mtile" href="' + p.href + '" style="--tint:' + p.tint + '">' +
        '<span class="mtile__top">' +
          '<span class="mtile__name">' + p.name + '</span>' +
        '</span>' +
        '<span class="mtile__pic"><img src="' + p.img + '" alt="" loading="lazy" /></span>' +
        '<span class="mtile__tag mtile__tag--' + p.fam + '">' + (PTAG[p.name] || MTAG[p.fam]) + '</span></a>';
    }).join('');
    var sheet = document.createElement('div');
    sheet.className = 'menusheet';
    sheet.setAttribute('data-menusheet', '');
    sheet.innerHTML =
      '<div class="menusheet__panel" role="dialog" aria-modal="true" aria-label="Shop menu">' +
        '<div class="menusheet__bar"><span class="menusheet__brand">Miracle Noodle</span>' +
          '<button class="menusheet__close" data-menu-close aria-label="Close menu">Close ✕</button></div>' +
        '<div class="menusheet__scroll">' +
          '<div class="menusheet__head"><h2 class="display">Shop</h2><span class="menusheet__tag">Doctor-curated</span></div>' +
          '<div class="menusheet__grid">' + tiles + '</div>' +
          '<div class="menusheet__ctarow"><a class="menusheet__byo" href="/pages/build-your-bundle">Build Your Own Bundle</a>' +
          '<a class="menusheet__all" href="' + (R.allProducts || '/collections/all') + '">Shop all products</a></div>' +
          '<nav class="menusheet__links" aria-label="More">' +
            '<a href="' + (R.education || '/pages/education') + '">Education</a><a href="' + (R.about || '/pages/about') + '">About the Doctor</a>' +
            '<a href="' + (R.reviews || '/pages/reviews') + '">Reviews</a>' +
            '<a href="/pages/subscription">Subscribe and Save</a>' +
            /* 2026-09-01: search moved off the mobile header so the Build Your Bundle CTA can take
               that slot. It binds itself — the [data-search-open] listener below is attached after
               this sheet is in the DOM, so it picks this button up with no extra wiring. */
            '<button type="button" data-search-open>Search</button></nav>' +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);
    var openBtns = document.querySelectorAll('[data-menu-open]');
    var open = function () { sheet.classList.add('is-open'); document.body.classList.add('menu-open'); openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); };
    var close = function () { sheet.classList.remove('is-open'); document.body.classList.remove('menu-open'); openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); };
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    sheet.querySelector('[data-menu-close]').addEventListener('click', close);
    /* 2026-09-24: Search lives in this menu on mobile. Close the menu when it's tapped, or the
       search panel opens underneath the menu and the shopper types into a hidden field. */
    var sheetSearch = sheet.querySelector('[data-search-open]');
    if (sheetSearch) sheetSearch.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // scroll progress bar
  const bar = document.querySelector('.scrollbar');
  if (bar) {
    let ticking = false;
    const update = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = `scaleX(${h > 0 ? window.scrollY / h : 0})`;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  // magnetic buttons
  if (!reduce && matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelectorAll('[data-magnetic]').forEach(el => {
      const strength = 0.32;
      el.addEventListener('mousemove', e => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * strength;
        const y = (e.clientY - r.top - r.height / 2) * strength;
        el.style.transform = `translate(${x}px,${y}px)`;
      });
      el.addEventListener('mouseleave', () => { el.style.transform = ''; });
    });
  }

  // reveal on scroll — LCP-safe: only elements BELOW the initial viewport are hidden (.pre),
  // so above-the-fold content paints before any JS runs (see matching app.css rules)
  const io = new IntersectionObserver((es) => {
    es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); e.target.classList.remove('pre'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 }); // threshold 0: tall blocks (legal prose) can never hit a ratio threshold on small viewports
  document.querySelectorAll('[data-reveal],[data-reveal-stagger]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top >= innerHeight || r.bottom <= 0) el.classList.add('pre');
    io.observe(el);
  });

  // count-up (seed end value first so it never renders blank)
  document.querySelectorAll('[data-count]').forEach(el => {
    const end = parseFloat(el.dataset.count), suf = el.dataset.suffix || '';
    el.textContent = (Number.isInteger(end) ? end : end.toFixed(1)) + suf;
  });
  const countIO = new IntersectionObserver((es) => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target, end = parseFloat(el.dataset.count), suf = el.dataset.suffix || '', dur = 1200;
      let t0 = null;
      const step = (t) => {
        if (!t0) t0 = t;
        const p = Math.min((t - t0) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (Number.isInteger(end) ? Math.round(end * eased) : (end * eased).toFixed(1)) + suf;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step); countIO.unobserve(el);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-count]').forEach(el => countIO.observe(el));

  // accordion
  document.querySelectorAll('[data-acc]').forEach(item => {
    const btn = item.querySelector('.acc__q');
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const open = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('[data-acc].is-open').forEach(o => { if (o !== item) { o.classList.remove('is-open'); const ob = o.querySelector('.acc__q'); if (ob) ob.setAttribute('aria-expanded', 'false'); } });
      item.classList.toggle('is-open', !open);
      btn.setAttribute('aria-expanded', !open ? 'true' : 'false');
    });
  });

  // PDP gallery
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        gallery.querySelectorAll('[data-thumb]').forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
        const img = t.querySelector('img');
        main.style.opacity = '0';
        setTimeout(() => { main.src = img.dataset.full || img.src; main.alt = img.alt; main.style.opacity = '1'; }, 160);
      });
    });
  }

  // PDP variant + price
  const buy = document.querySelector('[data-buy]');
  if (buy) {
    const fmt = n => '$' + n.toFixed(2);
    const effPrice = () => {
      const variant = buy.querySelector('input[name="variant"]:checked');
      const plan = buy.querySelector('input[name="plan"]:checked');
      const full = parseFloat(variant.dataset.price);
      const isSub = plan && plan.value === 'sub';
      return { full, isSub, price: isSub ? +(full * 0.85).toFixed(2) : full, variant };
    };
    const recalc = (animate) => {
      const { full, isSub, price, variant } = effPrice();
      const sub = +(full * 0.85).toFixed(2);
      const bags = parseInt(variant.dataset.bags || variant.value, 10);
      const onceEl = buy.querySelector('[data-price-once]'); if (onceEl) onceEl.textContent = fmt(full);
      const cmpOnce = buy.querySelector('[data-compare-once]');
      if (cmpOnce) { const c = parseFloat(variant.dataset.compare || full); cmpOnce.textContent = c > full ? fmt(c) : ''; cmpOnce.style.display = c > full ? '' : 'none'; }
      const fullEl = buy.querySelector('[data-price-full]'); if (fullEl) fullEl.textContent = fmt(full);
      const subEl = buy.querySelector('[data-price-sub]'); if (subEl) subEl.textContent = fmt(sub);
      buy.querySelectorAll('input[name="variant"]').forEach(v => {
        const tp = v.parentElement.querySelector('[data-tileprice]');
        if (!tp) return;
        const tprice = parseFloat(v.dataset.price), tbags = parseInt(v.dataset.bags || v.value, 10);
        tp.innerHTML = '<b>' + fmt(tprice) + '</b><i>' + fmt(tprice / tbags) + '/bag</i>';
      });
      const mealsEl = buy.querySelector('[data-meals]');
      if (mealsEl && bags) mealsEl.textContent = bags + ' meals · about ' + fmt(price / bags) + ' a meal' + (isSub ? ' · save ' + fmt(full - sub) : '');
      const cadEl = buy.querySelector('[data-cadence]'); if (cadEl) cadEl.style.display = isSub ? '' : 'none';
      const atcLabel = buy.querySelector('[data-atc-label]'); if (atcLabel) atcLabel.textContent = (isSub ? 'Subscribe · ' : 'Add to cart · ') + fmt(price);
      const stickyPrice = document.querySelector('[data-sticky-price]'); if (stickyPrice) stickyPrice.textContent = (bags ? bags + '-pack · ' : '') + (isSub ? 'Subscribe · ' : '') + fmt(price);
      const stickyBtn = document.querySelector('[data-sticky-atc]'); if (stickyBtn) stickyBtn.textContent = isSub ? 'Subscribe' : 'Add to cart';
      const stickyName = document.getElementById('pf-sticky-name');
      if (stickyName) stickyName.textContent = ((document.getElementById('pf-title') || {}).textContent || 'Egg White Spaghetti');
      if (animate) {
        buy.querySelectorAll('[data-price-once],[data-price-sub],[data-atc-label],[data-tileprice]').forEach(el => {
          el.classList.remove('numpop'); void el.offsetWidth; el.classList.add('numpop');
        });
      }
    };
    buy.querySelectorAll('input[name="variant"],input[name="plan"],[data-freq]').forEach(i => i.addEventListener('change', recalc));
    recalc();
    const qty = buy.querySelector('[data-qty]');
    if (qty) {
      const val = qty.querySelector('[data-qty-val]');
      qty.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        let n = parseInt(val.textContent, 10) + (b.dataset.step === '+' ? 1 : -1);
        val.textContent = Math.max(1, n);
      }));
    }
    const atc = buy.querySelector('[data-atc]');
    atc && atc.addEventListener('click', () => {
      const { isSub, price, variant } = effPrice();
      const qtyVal = parseInt((buy.querySelector('[data-qty-val]') || {}).textContent || '1', 10) || 1;
      /* slug-based id so the cart resolves canonical name/price/img from MNCatalog (audit A2/A3) */
      const slug = new URLSearchParams(location.search).get('p') || 'ew-spaghetti';
      const vsel = variant ? variant.value : '6';
      const id = vsel === 'trio' ? 'trio' : (window.MNCatalog && window.MNCatalog[slug] ? slug : 'ew-spaghetti') + '-' + vsel;
      const name = ((document.getElementById('pf-title') || {}).textContent || 'Egg White Spaghetti');
      const img = (window.MNCatalog && (window.MNCatalog[vsel === 'trio' ? 'trio' : slug] || {}).img) || 'images/packs/ew-spaghetti-front-u.webp';
      /* carry the subscription cadence into the line (audit A4) */
      const freqSel = buy.querySelector('[data-freq]');
      const cadence = isSub && freqSel ? ' · every ' + freqSel.value + ' weeks' : '';
      const vname = vsel + '-Pack';
      const vlabel = (vname + (isSub ? ' · Subscribe' + cadence : '')).trim();
      if (window.MNCart) window.MNCart.add({ id, name, price, img, variant: vlabel, qty: qtyVal });
      atc.classList.add('is-added'); const lbl = atc.querySelector('span');
      const orig = lbl.textContent; lbl.textContent = 'Added ✓ · ' + fmt(price);
      setTimeout(() => { atc.classList.remove('is-added'); lbl.textContent = orig; }, 1700);
    });
    const stickyAtc = document.querySelector('[data-sticky-atc]');
    if (stickyAtc) stickyAtc.addEventListener('click', e => { e.preventDefault(); atc.click(); });
  }

  // Ask Jonathan Carp, MD — assistant (depth: health + shipping + support + subscriptions)
  const bot = document.querySelector('.askbot');
  if (bot) {
    const KB = [
      // --- Product & health (Jonathan Carp, MD — first person, his voice) ---
      { cat: 'Product', q: 'Is it keto-friendly?', keys: 'keto carb carbs low-carb sugar glucose diabetic', a: "Keto-friendly by nature — and here's the why. The egg white noodles are under a gram of carb, the konjac shapes under a gram of net carb, because there's no flour and no grain to turn into sugar. So a full bowl of pasta still fits a low-carb day, and that's really the whole point." },
      { cat: 'Product', q: 'Egg white or konjac?', keys: 'egg white konjac shirataki difference which protein fiber', a: "Here's the simple split. Egg white noodles are clean protein — egg whites, water, and under 1% algae extract to hold the strand — so they're your pick when you want to stay full. Konjac is soluble fiber from the konjac plant — gentle, comfortable, and food for the natural bacteria in your gut. Want protein? Reach for egg white. Want fiber and a happy gut? Konjac." },
      { cat: 'Product', q: 'Best after a workout?', keys: 'workout exercise gym muscle recover protein amino post', a: "Egg white noodles, every time — because they're built from the amino acids your muscles use to rebuild. Egg white has a very high biological value, which basically means your body recognizes it and uses nearly all of it. Ten grams of clean protein, no bloat, ready before your shaker would be." },
      { cat: 'Product', q: 'How do I cook it?', keys: 'cook prepare make heat rinse drain recipe how', a: "They're ready to eat — there's nothing to actually cook. Konjac shapes: quick rinse, then warm them in a hot pan. Egg white noodles: drain, then a hot pan with a little oil — they want the oil, not a dry pan. Either way, they take on whatever flavor you bring. Want a recipe to start with?" },
      { cat: 'Product', q: "What's in it?", chip: false, keys: 'ingredients ingredient gluten grain allergen made of contains soy nut dairy label', a: "Less than you'd think. The egg white noodles are three things: egg whites, water, and a touch of algae extract to hold the strand together. The konjac shapes are konjac flour, water, and a little citric acid. No gluten, no grains, no flour — nothing you'd have to look up." },
      { cat: 'Product', q: 'Will it keep me full?', chip: false, keys: 'full fullness satiety hungry hunger satisfied appetite', a: "Yes — and here's why. Egg white is a clean protein your body uses almost completely, and protein slows digestion, so the full-and-satisfied feeling arrives and then stays. Add the konjac fiber and it holds even longer. Fullness that isn't willpower — it's a system." },
      { cat: 'Product', q: 'Eating smaller portions lately?', chip: false, keys: 'smaller portion less appetite eating light weight', a: "Then every bite has to count — and that's exactly what these are for. High protein, gentle fiber, very few calories, so a small bowl still gives your body what it's looking for. When you're eating less, make each bite earn its place." },
      { cat: 'Product', q: 'How should I store it?', chip: false, keys: 'store storage shelf life expire fridge pantry last fresh', a: "Easy — pantry-stable until you open it, so a cool, dry shelf is all it needs, no fridge. Once a pouch is open, keep the extra noodles in water in the fridge and use them within a few days." },
      { cat: 'Product', q: 'Will it keep me full?', chip: false, keys: 'blood sugar glucose spike crash steady cgm flat insulin a1c', a: "For your own numbers, that's a conversation for your doctor. What I can tell you is what's in the bowl: clean protein and fiber instead of refined flour. Protein slows digestion, so a bowl keeps you full and satisfied, without the heavy feeling a flour pasta leaves behind." },
      { cat: 'Product', q: 'Why does it smell?', chip: false, suggest: false, keys: 'smell smells odor odour fishy scent stink funny weird open pouch rinse', a: "That smell is the packing water, not the noodle — and it rinses off in about thirty seconds. Konjac sits in its own natural water inside the pouch, so there's a faint scent when you first open it. Drain, rinse under cold water, and it's gone. The egg white shapes don't have it at all." },
      { cat: 'Product', q: 'Do they taste like pasta?', keys: 'taste tastes tasty flavor flavour like pasta real bland good bad', a: "The egg white shapes are the ones that surprise people — they twirl, they hold sauce, and they bite close to the real thing. Konjac is more neutral, because the fiber itself is mild, so treat it as a blank canvas that takes on whatever flavor you bring it. Cook it the way the bag says and it stops being a substitute and just becomes dinner." },
      { cat: 'Product', q: 'Is the texture rubbery?', chip: false, keys: 'texture rubbery chewy bouncy squeaky firm soft mushy bite mouthfeel', a: "It's firmer than wheat pasta, and that's the fiber doing its job — konjac holds its shape instead of collapsing. If you want the most pasta-like bite, dry-pan the konjac for a minute or two before anything else goes in; the extra water cooks off and the texture tightens right up. The egg white shapes are softer, closer to a classic noodle." },
      { cat: 'Product', q: 'Is it vegan?', chip: false, keys: 'vegan vegetarian plant based animal dairy free', a: "The konjac shapes are — konjac flour, water, and a little citric acid, all from the konjac plant. The egg white shapes aren't, because egg white is exactly what they're made of. So if you're eating plant-based, konjac is your line." },
      { cat: 'Product', q: 'I have an egg allergy', chip: false, keys: 'egg allergy allergic allergen eggs intolerance sensitivity avoid', a: "Then the egg white line isn't for you — it's nothing but egg whites, water, and a touch of algae extract, so egg is the whole product. The konjac shapes have no egg in them at all: konjac flour, water, and citric acid. If you're managing a real allergy, read the bag and check with your own doctor first." },
      { cat: 'Product', q: 'What does the fiber actually do?', chip: false, keys: 'fiber fibre prebiotic glucomannan soluble insoluble gut bacteria microbiome digestion feed', a: "This is the part I find most interesting. There's insoluble fiber, which is kind of rough and moves things along, and there's soluble fiber, which is more like a gel — konjac is the gel kind. It isn't really there for you to digest; it's food for the natural bacteria in your gut. And when those bacteria are well fed and happy, they make short-chain fatty acids that support your body's own fullness signaling. That's the reason why a small bowl can sit so well." },
      { cat: 'Product', q: 'Will it bloat me?', chip: false, keys: 'bloat bloating gas digest digestion stomach upset uncomfortable sensitive comfortable', a: "Most people are comfortable from the first bowl, because soluble fiber is the gentle kind — more gel than rough. If you don't eat much fiber day to day, start with half a bag and let your gut catch up; the bacteria that handle it need a little time to build up. Ease into it and it settles." },
      { cat: 'Product', q: 'What is konjac?', chip: false, keys: 'konjac shirataki what plant glucomannan yam japan japanese origin', a: "It's a plant, and shirataki is the noodle made from it. Konjac has been eaten in Japan for centuries — I first had a bowl at a vegetarian restaurant outside Kyoto in 2006, and what struck me was that it's almost entirely soluble fiber, so there's very little in it for your body to turn into sugar. I came home from that trip and started Miracle Noodle so my own patients could eat it." },
      { cat: 'Product', q: 'Do I have to cook it?', chip: false, keys: 'ready raw cold straight microwave heat uncooked prepared boil', a: "There's nothing raw to cook — the noodles come cooked in the pouch, so heating them is about texture and flavor, not safety. Rinse the konjac and warm it in a hot pan and it's better for it. Cold, straight into a salad, works too." },
      { cat: 'Product', q: 'Can my kids eat it?', chip: false, keys: 'kids kid child children family toddler teen school', a: "Of course — it's food, and food with a very short label. The egg white shapes tend to be the easier sell, because the texture is closest to the pasta they already know. Make it the way you'd make any pasta night and let the sauce do the talking." },
      { cat: 'Product', q: 'Got a recipe?', chip: false, keys: 'recipe recipes idea dinner meal dish inspiration lunch', a: "Hundreds of them — they're under Recipes in the menu. If you want to start right now, the fastest one is this: hot pan, whatever vegetables and protein are already in your fridge, your sauce, then fold the noodles in at the end so they take on the flavor. That's dinner in about five minutes." },
      // --- Shipping & returns (standard support — practical, warm) ---
      { cat: 'Shipping', q: 'Do you offer free shipping?', keys: 'free shipping cost charge delivery postage', a: "Yes — free shipping on every order in the contiguous US, no minimum. The moment it ships, tracking lands in your inbox." },
      { cat: 'Shipping', q: 'How long does delivery take?', keys: 'long take time arrive deliver when fast tracking eta', a: "Most orders leave our warehouse within a couple of business days, and you'll get tracking as soon as they're on the way. Want an estimate on a specific order? Our team can pull it up — support@miraclenoodle.com or 1-800-948-4205." },
      { cat: 'Shipping', q: "What's your return policy?", keys: 'return refund guarantee risk money back not happy satisfaction', a: "Your first box is risk-free. If it isn't for you, just reach out and we'll make it right — support@miraclenoodle.com or 1-800-948-4205. No hoops." },
      { cat: 'Shipping', q: 'Do you ship internationally?', keys: 'international outside us canada overseas country abroad', a: "Free shipping covers the contiguous US right now. Anywhere else, drop our team a line at support@miraclenoodle.com and they'll tell you what's possible." },
      // --- Support ---
      { cat: 'Support', q: 'How do I reach you?', keys: 'contact support help phone call email reach human talk', a: "Real people, happy to help. Call 1-800-948-4205 or email support@miraclenoodle.com and we'll get you sorted." },
      { cat: 'Support', q: 'Can I buy it in stores?', keys: 'store buy retail shop near locator find location', a: "Yes — you'll find us in retailers nationwide. Use the store locator to find Miracle Noodle near you, or order direct here with free shipping." },
      { cat: 'Support', q: 'Where is my order?', keys: 'where order track tracking shipped status package late missing arrive', a: "Tracking lands in your inbox the moment your box ships, so start there. If it hasn't shown up or something looks off, our team can pull up your order — support@miraclenoodle.com or 1-800-948-4205." },
      { cat: 'Support', q: 'Can I change my order?', chip: false, keys: 'change cancel edit modify order address wrong mistake amend', a: "If it hasn't shipped yet, usually yes. Reach the team quickly at support@miraclenoodle.com or 1-800-948-4205 and they'll catch it if they can." },
      // --- Subscriptions ---
      { cat: 'Subscriptions', q: 'How does subscribe & save work?', keys: 'subscribe subscription save recurring auto discount plan', a: "Pick a delivery cadence at checkout — every 1, 2, or 3 months — and save 10% on every order. Skip, swap, or cancel anytime from your account — no phone call, no hassle." },
      { cat: 'Subscriptions', q: 'How do I skip or cancel?', keys: 'skip cancel pause change manage stop edit subscription', a: "All from your account — skip a shipment, change the date, swap products, or cancel whenever. Want a hand? support@miraclenoodle.com or 1-800-948-4205." },
      { cat: 'Subscriptions', q: 'Can I change what I get?', chip: false, keys: 'swap switch product cadence frequency often date flavor different', a: "Anytime, from your account — swap products, change how often it arrives, move the date, or pause it. The cadences are every 1, 2, or 3 months, and the 10% stays with you either way." }
    ];
    const GREETING = "Hi — these answers are grounded in Jonathan Carp, MD's teaching, not live medical advice. Ask about recipes, protein, swaps, or your order, and I'll give you the why. For anything personal or clinical, talk with your own doctor.";
    const DEFAULT = "Good question — I want to get this one right. Tell me a little more about what you're after, or reach our team directly at support@miraclenoodle.com or 1-800-948-4205, and we'll take care of you.";
    const body = bot.querySelector('.askbot__body');
    const firstMsg = body && body.querySelector('.askbot__msg--bot');
    if (firstMsg) firstMsg.textContent = GREETING;
    const tabsEl = bot.querySelector('[data-tabs]');
    const chipsEl = bot.querySelector('[data-chips]');
    const cats = [...new Set(KB.map(k => k.cat))];
    let activeCat = cats[0];
    const track = (n, d) => { try { window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish && window.Shopify.analytics.publish(n, d || {}); } catch (e) {} try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: n }, d || {})); } catch (e) {} try { window.gtag && window.gtag('event', n, d || {}); } catch (e) {} };
    /* 2026-09-23: don't auto-focus the input on phones — it pops the keyboard and scrolls the
       panel so its header and close button end up off-screen on small iPhones. */
    const open = () => { bot.classList.add('is-open'); track('askbot_open'); if (!matchMedia('(max-width:920px)').matches) setTimeout(() => bot.querySelector('.askbot__input input')?.focus(), 350); };
    const close = () => bot.classList.remove('is-open');
    bot.querySelector('.askbot__launch')?.addEventListener('click', open);
    document.querySelectorAll('[data-askbot-open]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); open(); }));
    bot.querySelector('.askbot__close')?.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    /* Mobile: primary CTAs are full-width, so the launcher lands on top of them.
       Tuck the launcher while a primary CTA is on screen — the homepage hero CTAs
       and the PDP buy-box add-to-cart — and reveal once it scrolls past.
       Desktop keeps the always-visible launcher (no full-width CTA there). */
    (function () {
      /* 2026-09-23: also tuck it over the whole buy box (pack tiles and prices sat under the
         launcher, not just the add-to-cart), the pair/cross-sell cards, and the footer signup. */
      var watch = [document.querySelector('.hero--scene .hero__ctas'), document.querySelector('[data-atc]'),
        document.querySelector('.buy'), document.querySelector('.syscx'), document.querySelector('.footer')].filter(Boolean);
      if (!watch.length || !('IntersectionObserver' in window)) return;
      var mq = matchMedia('(max-width:920px)');
      var vis = [];
      var apply = function () { bot.classList.toggle('askbot--peek', mq.matches && vis.length > 0 && !bot.classList.contains('is-open')); };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = vis.indexOf(en.target);
          if (en.isIntersecting && i < 0) vis.push(en.target);
          else if (!en.isIntersecting && i > -1) vis.splice(i, 1);
        });
        apply();
      }, { threshold: 0 });
      watch.forEach(function (el) { io.observe(el); });
      if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
    })();

    /* 2026-07-31: keep the launcher off the homepage trust ticker.
       .askbot is position:fixed bottom-right; .trustbar sits at the base of the homepage hero,
       so at common viewport heights the pill landed directly on top of "Free shipping /
       Doctor-curated". Lift the launcher by the ticker's measured height while it is on screen
       instead of hiding it, so the CTA stays reachable. No-op on every other page (only the
       homepage renders .trustbar). */
    (function () {
      var tb = document.querySelector('.trustbar');
      if (!tb || !('IntersectionObserver' in window)) return;
      var lift = function (on) {
        bot.style.setProperty('--askbot-lift', on ? (tb.offsetHeight + 14) + 'px' : '0px');
        bot.classList.toggle('askbot--lift', on);
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { lift(en.isIntersecting); });
      }, { threshold: 0 }).observe(tb);
    })();

    /* proactive nudge — one gentle objection-busting teaser per session (not on the homepage) */
    (function () {
      if (document.querySelector('.hero--scene')) return;
      if (/checkout\.html/.test(location.pathname)) return; // never tease over the checkout form
      if (matchMedia('(max-width: 820px)').matches) return; // mobile: never auto-open — the bubble occludes the buy box (owner 2026-07-24)
      try { if (sessionStorage.getItem('mn_teaser')) return; } catch (e) {}
      const prompts = [
        'Wondering how it tastes — or how to cook it? Ask me.',
        'Not sure which shape to start with? I can help.',
        'Questions about carbs, protein, or staying full? Ask the doctor.'
      ];
      const msg = prompts[Math.floor(Math.random() * prompts.length)];
      const t = document.createElement('div');
      t.className = 'askbot__teaser';
      t.innerHTML = '<button class="askbot__teaser-x" aria-label="Dismiss">×</button><span class="askbot__teaser-txt"></span>';
      t.querySelector('.askbot__teaser-txt').textContent = msg;
      bot.appendChild(t);
      let shown = false;
      const dismiss = () => { t.classList.remove('show'); try { sessionStorage.setItem('mn_teaser', '1'); } catch (e) {} setTimeout(() => t.remove(), 400); };
      const show = () => { if (shown || bot.classList.contains('is-open')) return; shown = true; t.classList.add('show');
        try { sessionStorage.setItem('mn_teaser', '1'); } catch (e) {} }; // one show per session, not one dismiss
      t.querySelector('.askbot__teaser-txt').addEventListener('click', () => { open(); dismiss(); });
      t.querySelector('.askbot__teaser-x').addEventListener('click', (e) => { e.stopPropagation(); dismiss(); });
      setTimeout(show, 14000);
      const onScroll = () => { const y = window.scrollY || document.documentElement.scrollTop; const max = document.documentElement.scrollHeight - window.innerHeight; if (max > 0 && y / max > 0.45) { show(); window.removeEventListener('scroll', onScroll); } };
      window.addEventListener('scroll', onScroll, { passive: true });
    })();
    const scroll = () => { body.scrollTop = body.scrollHeight; };
    // Chat-style scroll-to-bottom lands the reader at the END of a long answer, past the part
    // that answers their question. Put the answer's first line at the top of the pane instead;
    // answers shorter than the pane just clamp back to the bottom, as before.
    const scrollToMsg = (el) => { body.scrollTop += el.getBoundingClientRect().top - body.getBoundingClientRect().top - 10; };
    const push = (text, who) => { if (who === 'user') body.querySelectorAll('.askbot__follows').forEach(el => el.remove()); const m = document.createElement('div'); m.className = 'askbot__msg askbot__msg--' + who; m.textContent = text; body.appendChild(m); scroll(); return m; };
    const pick2 = (arr) => { const a = arr.slice(); for (let i = a.length - 1; i > 0; i -= 1) { const j = Math.floor(Math.random() * (i + 1)); const tmp = a[i]; a[i] = a[j]; a[j] = tmp; } return a.slice(0, 2); };
    // suggest:false = answer it fully when asked, but never raise it unprompted (no chip, no follow-up).
    // For objections we shouldn't put in a shopper's head if they weren't already wondering.
    const suggestable = (x) => x.suggest !== false;
    const followsFor = (k) => {
      if (!k) return pick2(KB.filter(x => x.cat === 'Product' && suggestable(x)));
      const same = KB.filter(x => x.cat === k.cat && x.q !== k.q && suggestable(x));
      return same.length >= 2 ? pick2(same) : pick2(KB.filter(x => x.q !== k.q && suggestable(x)));
    };
    const ask = (k) => { push(k.q, 'user'); track('askbot_ask', { question: k.q, source: 'chip' }); reply(k.a, k); };
    const renderFollows = (list) => {
      if (!list || !list.length) return;
      const wrap = document.createElement('div'); wrap.className = 'askbot__follows';
      list.forEach(k => { const b = document.createElement('button'); b.className = 'askbot__follow'; b.textContent = k.q; b.addEventListener('click', () => { wrap.remove(); ask(k); }); wrap.appendChild(b); });
      body.appendChild(wrap); // no scroll — reply() positions the pane once the follows exist
    };
    const reply = (text, sourceK) => {
      const t = document.createElement('div'); t.className = 'askbot__typing'; t.innerHTML = '<i></i><i></i><i></i>';
      body.appendChild(t); scroll();
      const delay = Math.min(1500, 520 + text.length * 9); // longer answers "take longer to type"
      setTimeout(() => { t.remove(); const m = push(text, 'bot'); renderFollows(followsFor(sourceK)); scrollToMsg(m); }, delay);
    };
    const renderTabs = () => {
      if (!tabsEl) return; tabsEl.textContent = '';
      cats.forEach(c => { const b = document.createElement('button'); b.className = 'askbot__tab' + (c === activeCat ? ' is-active' : ''); b.textContent = c; b.addEventListener('click', () => { activeCat = c; renderTabs(); renderChips(); }); tabsEl.appendChild(b); });
    };
    const renderChips = () => {
      if (!chipsEl) return; chipsEl.textContent = '';
      KB.filter(k => k.cat === activeCat && k.chip !== false).forEach(k => { const b = document.createElement('button'); b.className = 'askbot__chip'; b.textContent = k.q; b.addEventListener('click', () => ask(k)); chipsEl.appendChild(b); });
    };
    const answer = (text) => {
      const words = text.toLowerCase().split(/\W+/).filter(w => w.length > 2);
      let best = null, score = 0;
      KB.forEach(k => { const hay = (k.q + ' ' + (k.keys || '')).toLowerCase(); let s = 0; words.forEach(w => { if (hay.includes(w)) s += 1; }); if (s > score) { score = s; best = k; } });
      return score >= 1 && best ? best : null;
    };
    renderTabs(); renderChips();
    bot.querySelector('.askbot__input')?.addEventListener('submit', e => {
      e.preventDefault(); const inp = e.target.querySelector('input'); const v = inp.value.trim();
      if (!v) return; push(v, 'user'); track('askbot_ask', { question: v, source: 'typed' }); inp.value = ''; const best = answer(v); reply(best ? best.a : DEFAULT, best);
    });
  }

  // 360° drag-to-spin
  const spin = document.querySelector('[data-spin360]');
  if (spin) {
    const TOTAL = parseInt(spin.dataset.frames, 10) || 96;
    const pad = n => String(n).padStart(3, '0');
    const src = i => `frames/spin/f${pad(((i % TOTAL) + TOTAL) % TOTAL + 1)}.webp`;
    const img = spin.querySelector('img');
    const hint = spin.querySelector('[data-spin-hint]');
    let frame = 0, dragging = false, startX = 0, lastX = 0, startFrame = 0, auto = null, vel = 0, inertia = null, idle = null;
    // lazy preload — only when the widget scrolls into view (saves ~3MB on the mobile critical path)
    let preloaded = false;
    const preload = () => { if (preloaded || reduce) return; preloaded = true; for (let i = 0; i < TOTAL; i += 1) { const im = new Image(); im.src = src(i); } };
    const render = () => { img.src = src(Math.round(frame)); };
    const setFrame = f => { frame = ((f % TOTAL) + TOTAL) % TOTAL; render(); };
    const startAuto = () => { if (auto || dragging || reduce) return; auto = setInterval(() => setFrame(frame + 0.6), 60); };
    const stopAuto = () => { clearInterval(auto); auto = null; };
    const scheduleResume = () => { clearTimeout(idle); idle = setTimeout(startAuto, 2600); }; // auto-rotate resumes after the user rests
    const down = e => { dragging = true; stopAuto(); clearTimeout(idle); if (inertia) cancelAnimationFrame(inertia); if (hint) hint.style.opacity = '0';
      startX = lastX = (e.touches ? e.touches[0].clientX : e.clientX); startFrame = frame; vel = 0; spin.classList.add('grabbing'); };
    const move = e => { if (!dragging) return; e.preventDefault();
      const x = (e.touches ? e.touches[0].clientX : e.clientX);
      setFrame(startFrame + (x - startX) / spin.clientWidth * TOTAL * 1.4);
      vel = (x - lastX) / spin.clientWidth * TOTAL * 1.4; lastX = x; };
    const up = () => { if (!dragging) return; dragging = false; spin.classList.remove('grabbing');
      const glide = () => { if (Math.abs(vel) < 0.06) { scheduleResume(); return; } setFrame(frame + vel); vel *= 0.94; inertia = requestAnimationFrame(glide); };
      inertia = requestAnimationFrame(glide); }; // release momentum, then resume auto when it settles
    spin.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    spin.addEventListener('touchstart', down, { passive: true }); spin.addEventListener('touchmove', move, { passive: false }); spin.addEventListener('touchend', up);
    render();
    if (reduce && hint) hint.style.display = 'none';
    const sObs = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { preload(); startAuto(); } else stopAuto(); }), { threshold: 0.4 });
    sObs.observe(spin);
  }

  // ---- Slide-in cart ----
  (function () {
    /* Real Shopify cart via the AJAX Cart API. The drawer markup is server-rendered by
       snippets/mn-cart-drawer.liquid (real line items) and included in layout/theme.liquid;
       here we grab that node and keep it in sync. Kept structurally 1:1 with the source mock
       (same classes, data-hooks, open/close, event names) so the ported CSS works unchanged. */
    const el = document.getElementById('cart');
    if (!el) return;
    const ROOT = window.MNCartRoot || '/';
    let cart = { items: [], item_count: 0, items_subtotal_price: 0 };
    const itemsEl = el.querySelector('[data-citems]'), subEl = el.querySelector('[data-csub]');
    const discsEl = el.querySelector('[data-cdiscs]'), totEl = el.querySelector('[data-ctot]');
    const fmt = n => '$' + n.toFixed(2);           // dollars — upsell cards / MNCatalog prices
    const money = c => '$' + (c / 100).toFixed(2); // Shopify money: cents → $XX.XX
    const open = () => { el.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const close = () => { el.classList.remove('is-open'); document.body.style.overflow = ''; };
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const syncBadges = () => document.querySelectorAll('[data-cart-count],[data-cartn]').forEach(b => { b.textContent = cart.item_count; });
    const isByo = it => !!(it && it.properties && it.properties._byo_box);
    const itemHTML = (it, line) => {
      const meta = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="citem"><img class="citem__img" src="' + esc(it.image || '') + '" alt="" />' +
      '<div><div class="citem__name">' + esc(it.product_title) + '</div>' +
      (meta ? '<div class="citem__meta">' + esc(meta) + '</div>' : '') +
      '<div class="citem__qty"><button data-dec="' + line + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-inc="' + line + '" aria-label="Increase">+</button></div></div>' +
      '<div class="citem__r"><div class="citem__price">' + money(it.final_line_price) + '</div><button class="citem__remove" data-rm="' + line + '">Remove</button></div></div>';
    };
    /* 2026-08-04: a Build-Your-Bundle box is ONE unit, not six independent lines. Rendering
       its packs as ordinary rows let a shopper delete five of the six and check out with a
       single $4.75 pack — a box priced as a six-pack, shipped as one item. Every line carrying
       `_byo_box` is folded into one card with no per-pack stepper and one Remove that clears
       the whole group. Editing the mix happens on the builder, which is where the 6-pack rule
       is enforced. Mirrored server-side in snippets/mn-cart-drawer.liquid — keep in sync. */
    const byoCardHTML = group => {
      const first = group[0].it;
      const label = first.properties._byo_box || 'Build Your Bundle';
      const packs = group.reduce((n, e) => n + e.it.quantity, 0);
      const price = group.reduce((n, e) => n + (e.it.final_line_price || 0), 0);
      const plan = (first.selling_plan_allocation && first.selling_plan_allocation.selling_plan)
        ? first.selling_plan_allocation.selling_plan.name : '';
      const rows = group.map(e =>
        '<li>' + esc(e.it.product_title) + ' <span>&times;' + e.it.quantity + '</span></li>').join('');
      /* the all-six-packs shot, not one pack's own photo — a lone Rice bag reads as a
         single-item order. URL comes from the drawer's data-byoimg (set in Liquid). */
      const img = el.getAttribute('data-byoimg') || first.image || '';
      return '<div class="citem citem--byo"><img class="citem__img" src="' + esc(img) + '" alt="All six Miracle Noodle packs" />' +
      '<div><div class="citem__name">' + esc(label) + '</div>' +
      '<div class="citem__meta">' + packs + ' pack' + (packs === 1 ? '' : 's') + (plan ? ' &middot; ' + esc(plan) : '') + '</div>' +
      '<ul class="citem__bundle">' + rows + '</ul></div>' +
      '<div class="citem__r"><div class="citem__price">' + money(price) + '</div>' +
      '<button class="citem__remove" data-rmbyo="1">Remove</button></div></div>';
    };
    const render = () => {
      const lines = cart.items || [];
      if (!lines.length) itemsEl.innerHTML = '<p class="cart__empty">Your cart is empty.</p>';
      else {
        const byo = [], rest = [];
        lines.forEach((it, i) => (isByo(it) ? byo : rest).push({ it: it, line: i + 1 })); // lines are 1-based
        itemsEl.innerHTML = (byo.length ? byoCardHTML(byo) : '') +
          rest.map(e => itemHTML(e.it, e.line)).join('');
      }
      const sub = cart.items_subtotal_price || 0;
      subEl.textContent = money(sub);
      /* 2026-07-26: cart-level (order) discounts — Alia AL######## codes are "amount off order" and
         are NOT in items_subtotal_price, so an applied code looked like it had failed. Keep the
         server-rendered rows in sync after qty changes / adds. */
      const discs = cart.cart_level_discount_applications || [];
      if (discsEl) discsEl.innerHTML = discs.map(d =>
        '<div class="cart__disc"><span>' + esc(d.title) + '</span><b>&minus;' + money(d.total_allocated_amount) + '</b></div>').join('');
      if (totEl) {
        totEl.hidden = discs.length === 0;
        const tb = totEl.querySelector('b');
        if (tb) tb.textContent = money(cart.total_price || 0);
      }
      // 2026-07-31: mirror of the `has_byo` guard in snippets/mn-cart-drawer.liquid. The Liquid
      // guard is only correct at page load; this drawer is re-rendered on every AJAX cart change
      // (and render() does not otherwise touch .cart__upsell), so without this a shopper who
      // builds a BYO box keeps seeing the "Build Your Bundle" upsell for the box they just built.
      // Uses style.display, not [hidden] — a class selector on .cart__upsell would outrank the
      // UA [hidden] rule in this theme.
      const upsellEl = el.querySelector('.cart__upsell');
      if (upsellEl) {
        const hasByo = lines.some(it => it.properties && it.properties._byo_box);
        upsellEl.style.display = hasByo ? 'none' : '';
      }
      syncBadges();
    };
    const setCart = c => { cart = c; render(); };
    const fetchCart = () => fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json()).then(setCart).catch(() => {});
    const changeLine = (line, quantity) => fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(r => r.json()).then(setCart).catch(() => {});
    /* Removing a bundle means zeroing several lines at once. cart/change.js renumbers the
       remaining lines after each call, so sequential calls would delete the wrong rows —
       cart/update.js takes ONE array of quantities in cart.items order instead. */
    const removeByo = () => fetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: (cart.items || []).map(it => (isByo(it) ? 0 : it.quantity)) })
    }).then(r => r.json()).then(setCart).catch(() => {});
    itemsEl.addEventListener('click', e => {
      const inc = e.target.getAttribute('data-inc'), dec = e.target.getAttribute('data-dec'), rm = e.target.getAttribute('data-rm');
      if (e.target.getAttribute('data-rmbyo') !== null) { removeByo(); }
      else if (inc !== null) { const it = cart.items[+inc - 1]; if (it) changeLine(+inc, it.quantity + 1); }
      else if (dec !== null) { const it = cart.items[+dec - 1]; if (it) changeLine(+dec, it.quantity - 1); }
      else if (rm !== null) { changeLine(+rm, 0); }
    });
    el.querySelectorAll('[data-cc]').forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    window.MNCart = {
      add(item) {
        /* resolve the source's slug-based line id ("<slug>-6") to a Shopify variant id and POST it.
           A direct item.variantId (passed by the PDP for every product, incl. generic/unmapped
           ones absent from MNCatalog) takes precedence over slug-based resolution. */
        const vid = item.variantId || window.MNVariantId(item.id);
        if (!vid) { console.warn('MNCart: no Shopify variant mapped for', item.id); open(); return Promise.resolve(); }
        const payload = { id: vid, quantity: item.qty || 1 };
        if (item.selling_plan) payload.selling_plan = item.selling_plan;
        /* 2026-08-04: line-item properties were silently dropped here. The BYO builder posts
           five packs itself and hands the SIXTH to this add() so the drawer re-fetches and
           opens — so exactly one pack per box arrived WITHOUT `_byo_box` and fell outside the
           bundle group (removable on its own, and mergeable with an unrelated line of the same
           variant). Forward them. */
        if (item.properties) payload.properties = item.properties;
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(r => r.json()).then(() => fetchCart()).then(() => open()).catch(() => open());
      },
      items() { return (cart.items || []).map(it => ({ id: it.id, name: it.product_title, variant: it.variant_title, qty: it.quantity, price: (it.final_price || 0) / 100 })); },
      open
    };
    fetchCart();
    // ---- upsell carousel (Graza-style "want to add" slider) ----
    (function () {
      const track = el.querySelector('[data-utrack]'), dotsEl = el.querySelector('[data-udots]');
      if (!track) return;
      const C = window.MNCatalog;
      const UP = [
        { id: 'ew-angelhair-6', name: C['ew-angelhair'].name, meta: '6 bags · 10g protein', price: C['ew-angelhair'].p6, img: C['ew-angelhair'].img },
        { id: 'rte-fettuccine-6', name: C['rte-fettuccine'].name, meta: '6 bags · 1g net carb', price: C['rte-fettuccine'].p6, img: C['rte-fettuccine'].img },
        { id: 'rte-rice-6', name: C['rte-rice'].name, meta: '6 bags · grain-free', price: C['rte-rice'].p6, img: C['rte-rice'].img }
      ].filter(u => !(cart.items || []).some(i => String(i.id) === String(window.MNVariantId(u.id))));
      if (!UP.length) { const us = el.querySelector('.cart__upsell'); if (us) us.style.display = 'none'; return; }
      track.innerHTML = UP.map((p, i) =>
        '<div class="ucard"><img src="' + esc(p.img) + '" alt="" />' +
        '<div class="ucard__b"><p class="ucard__q">Add ' + esc(p.name) + '?</p>' +
        '<p class="ucard__meta">' + esc(p.meta) + '</p>' +
        '<div class="ucard__row"><span class="ucard__price">' + fmt(p.price) + '</span>' +
        '<button class="ucard__add" data-uadd="' + i + '">Add to cart</button></div></div></div>'
      ).join('');
      dotsEl.innerHTML = UP.map((_, i) =>
        '<button class="upsell__dot' + (i === 0 ? ' on' : '') + '" data-udot="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>'
      ).join('');
      let ui = 0, timer = null;
      const goU = n => {
        ui = (n + UP.length) % UP.length;
        track.style.transform = 'translateX(-' + (ui * 100) + '%)';
        dotsEl.querySelectorAll('.upsell__dot').forEach((d, j) => d.classList.toggle('on', j === ui));
      };
      const auto = () => { if (matchMedia('(prefers-reduced-motion:reduce)').matches) return; timer = setInterval(() => { if (!el.classList.contains('is-open')) return; goU(ui + 1); }, 4500); };
      const resetAuto = () => { if (timer) clearInterval(timer); auto(); };
      dotsEl.querySelectorAll('[data-udot]').forEach(d => d.addEventListener('click', () => { goU(+d.dataset.udot); resetAuto(); }));
      track.querySelectorAll('[data-uadd]').forEach(b => b.addEventListener('click', () => {
        const p = UP[+b.dataset.uadd];
        window.MNCart.add({ id: p.id, name: p.name, price: p.price, img: p.img, variant: '6-Pack', qty: 1 });
        b.textContent = 'Added ✓';
        setTimeout(() => { b.textContent = 'Add to cart'; }, 1300);
      }));
      auto();
    })();
    document.querySelectorAll('.nav__cart').forEach(c => { c.style.cursor = 'pointer'; c.setAttribute('role', 'button'); c.setAttribute('tabindex', '0'); c.setAttribute('aria-label', 'Open cart'); c.addEventListener('click', open); c.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }); });
    // collection "Add +" → cart (without navigating to the PDP)
    document.querySelectorAll('.pcard__add').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        const card = btn.closest('.pcard'); if (!card) return;
        /* derive the slug from the card's PDP link → canonical price/name/img (audit A2) */
        const href = card.getAttribute('href') || (card.querySelector('a[href*="product.html"]') || {}).getAttribute && card.querySelector('a[href*="product.html"]').getAttribute('href') || '';
        const sm = String(href).match(/[?&]p=([a-z-]+)/);
        const c = sm && window.MNCatalog ? window.MNCatalog[sm[1]] : null;
        if (!c) { location.href = href || (window.MNRoutes && window.MNRoutes.allProducts) || '/collections/all'; return; }
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = 'Add +'; }, 1400);
        if (window.MNCart) window.MNCart.add({ id: sm[1] + '-6', name: c.name, price: c.p6, img: c.img, variant: '6-Pack', qty: 1 });
      });
    });
  })();

  // ---- Search ----
  (function () {
    const PRODUCTS = window.MNSearchIndex || [
      { name: 'Egg White Spaghetti', url: 'product.html?p=ew-spaghetti', img: 'images/packs/ew-spaghetti-front-u.webp', tag: 'Egg White', keys: 'noodle noodles pasta spaghetti protein low carb keto egg' },
      { name: 'Egg White Angel Hair', url: 'product.html?p=ew-angelhair', img: 'images/packs/ew-angelhair-front-u.webp', tag: 'Egg White', keys: 'noodle noodles pasta angel hair vermicelli thin protein egg' },
      { name: 'Konjac Spaghetti', url: 'product.html?p=rte-spaghetti', img: 'images/packs/rte-spaghetti-front-org.webp', tag: 'Ready to eat', keys: 'noodle noodles pasta spaghetti shirataki konjac fiber low carb keto' },
      { name: 'Konjac Fettuccine', url: 'product.html?p=rte-fettuccine', img: 'images/packs/rte-fettuccine-front-org.webp', tag: 'Ready to eat', keys: 'noodle noodles pasta shirataki konjac fettuccine fiber low carb keto' },
      { name: 'Konjac Angel Hair', url: 'product.html?p=rte-angelhair', img: 'images/packs/rte-angelhair-front-org.webp', tag: 'Ready to eat', keys: 'noodle noodles pasta shirataki konjac angel hair fiber low carb keto' },
      { name: 'Konjac Rice', url: 'product.html?p=rte-rice', img: 'images/packs/rte-rice-front-org.webp', tag: 'Konjac', keys: 'rice grain-free shirataki konjac fiber low carb keto cauliflower' },
      { name: 'All recipes', url: 'recipes.html', img: 'images/dinner-1.webp', tag: 'Recipes', keys: 'recipe recipes cook dinner meal ideas' },
      { name: 'Education — how it works', url: 'education.html', img: 'images/lifestyle-1.webp', tag: 'Learn', keys: 'learn education blood sugar fiber protein konjac science doctor' }
    ];
    const el = document.createElement('div'); el.className = 'search'; el.id = 'search';
    el.innerHTML =
      '<div class="search__overlay" data-sc></div><div class="search__panel" role="dialog" aria-modal="true" aria-label="Search">' +
      '<div class="search__bar"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
      '<input type="text" placeholder="Search products, recipes, articles…" aria-label="Search products, recipes, articles" data-si /><button data-sc>Close</button></div>' +
      '<div class="search__results" data-sr></div></div>';
    document.body.appendChild(el);
    const input = el.querySelector('[data-si]'), results = el.querySelector('[data-sr]');
    const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    // Prefer the live-search API image (plain URL) → featured_image.url → fallback.
    const imgOf = it => (typeof it.image === 'string' && it.image) ? it.image : (it.featured_image && it.featured_image.url) || '';
    const FALLBACK_IMG = (PRODUCTS.find(p => p.tag === 'Recipes') || {}).img || '';
    // Derive a readable blog label from a /blogs/<handle>/... url.
    const blogName = url => {
      const m = String(url).match(/\/blogs\/([^\/?]+)/);
      return m ? m[1].replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'Article';
    };
    const itemHTML = (img, label, title, url, isPage) => {
      const im = (!isPage && img) ? '<img src="' + esc(img) + '" alt="" />' : '';
      return '<a class="sresult' + (isPage ? ' sresult--page' : '') + '" href="' + esc(url) + '">' + im +
        '<div><span>' + esc(label) + '</span><b>' + esc(title) + '</b></div></a>';
    };
    const group = name => '<h3 class="search__group">' + esc(name) + '</h3>';
    const noResults = q => '<p class="search__empty">No results for “' + esc(q) + '” — try “konjac”, “recipes”, or “shipping”.</p>';

    // Empty-query browse state: the default MNSearchIndex grid (products + recipes/education tiles).
    const renderBrowse = () => { results.innerHTML = PRODUCTS.map(p => itemHTML(p.img, p.tag, p.name, p.url, false)).join(''); };
    // API failure fallback: the original static-index substring filter — never a broken overlay.
    const renderStatic = q => {
      const lc = q.toLowerCase();
      const list = PRODUCTS.filter(p => (p.name + ' ' + p.tag + ' ' + (p.keys || '')).toLowerCase().indexOf(lc) > -1);
      results.innerHTML = list.length ? list.map(p => itemHTML(p.img, p.tag, p.name, p.url, false)).join('') : noResults(q);
    };
    const renderResults = (q, r) => {
      const prods = (r.products || []).slice(0, 6);
      const arts = (r.articles || []).slice(0, 6);
      const pages = (r.pages || []).slice(0, 6);
      let html = '';
      if (prods.length) html += group('Products') + prods.map(p => itemHTML(imgOf(p), p.type || 'Product', p.title, p.url, false)).join('');
      if (arts.length) html += group('Recipes & Articles') + arts.map(a => itemHTML(imgOf(a) || FALLBACK_IMG, blogName(a.url), a.title, a.url, false)).join('');
      if (pages.length) html += group('Pages') + pages.map(p => itemHTML('', 'Page', p.title, p.url, true)).join('');
      if (!html) { results.innerHTML = noResults(q); return; }
      html += '<a class="search__all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
      results.innerHTML = html;
    };

    let debTimer, ctrl;
    const doFetch = q => {
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page&resources[limit]=6' +
        '&resources[options][unavailable_products]=hide' +
        '&resources[options][fields]=title,product_type,variants.title,body';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
        .then(res => { if (!res.ok) throw new Error('bad status'); return res.json(); })
        .then(d => renderResults(q, (d.resources && d.resources.results) || {}))
        .catch(err => { if (err && err.name === 'AbortError') return; renderStatic(q); });
    };
    const schedule = () => {
      const q = input.value.trim();
      clearTimeout(debTimer);
      if (q.length < 2) { if (ctrl) ctrl.abort(); renderBrowse(); return; }
      debTimer = setTimeout(() => doFetch(q), 250);
    };
    const open = () => { el.classList.add('is-open'); document.body.style.overflow = 'hidden'; renderBrowse(); setTimeout(() => input.focus(), 300); };
    const close = () => { el.classList.remove('is-open'); document.body.style.overflow = ''; };
    el.querySelectorAll('[data-sc]').forEach(b => b.addEventListener('click', close));
    input.addEventListener('input', schedule);
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') { const q = input.value.trim(); if (q) location.href = '/search?q=' + encodeURIComponent(q); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    /* mount a trigger in the shared header — the overlay shipped on every page with no way to open it (audit D25) */
    const actions = document.querySelector('.nav__actions');
    if (actions && !document.querySelector('[data-search-open]')) {
      const sb = document.createElement('button');
      sb.className = 'nav__search'; sb.type = 'button'; sb.setAttribute('data-search-open', ''); sb.setAttribute('aria-label', 'Search');
      sb.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
      actions.insertBefore(sb, actions.firstChild);
    }
    document.querySelectorAll('[data-search-open]').forEach(b => b.addEventListener('click', open));
  })();

  // ---- Homepage lineup "Add to cart" buttons: real adds, not navigation (audit A8) ----
  document.querySelectorAll('[data-flow-add]').forEach(btn => {
    btn.addEventListener('click', () => {
      const slugK = btn.dataset.flowAdd, c = window.MNCatalog && window.MNCatalog[slugK];
      if (!c) return;
      if (window.MNCart) window.MNCart.add({ id: slugK + '-6', name: c.name, price: c.p6, img: c.img, variant: '6-Pack', qty: 1 });
      const orig = btn.textContent; btn.textContent = 'Added ✓';
      setTimeout(() => { btn.textContent = orig; }, 1400);
    });
  });
})();

/* ==== Shared: "flow" scroll-driven product slider (home #lineup + PDP) ==== */
(function () {
  var sections = [].slice.call(document.querySelectorAll('.flow'));
  /* NO early return when .flow is absent — this IIFE also binds the video-carousel
     arrows and the founder film modal below; guard removed 2026-07-24 after the last
     .flow section was retired and the guard silently disabled both. */
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var pin = function () { return matchMedia('(min-width:821px)').matches && !reduce; };
  sections.forEach(function (sec) {
    var slides = [].slice.call(sec.querySelectorAll('.flow__slide'));
    var items = [].slice.call(sec.querySelectorAll('.flow__item'));
    var rows = [].slice.call(sec.querySelectorAll('[data-flow]'));
    var bar = sec.querySelector('[data-flow-bar]');
    var n = items.length, cur = -1;
    if (!n) return;
    function isDarkHex(h) {
      if (!h) return false; h = h.replace('#', '');
      if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
      var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) < 140;
    }
    function paint(i) {
      var d = items[i];
      if (d.dataset.bg) { sec.style.background = d.dataset.bg; sec.style.setProperty('--bg', d.dataset.bg); sec.classList.toggle('flow--dark', isDarkHex(d.dataset.bg)); }
      if (d.dataset.fg) { sec.style.color = d.dataset.fg; sec.style.setProperty('--fg', d.dataset.fg); }
      if (d.dataset.ac) sec.style.setProperty('--ac', d.dataset.ac);
    }
    function go(i) {
      if (i === cur) return;
      var prev = cur; cur = i;
      slides.forEach(function (s, j) { s.classList.remove('on', 'out'); if (j === i) s.classList.add('on'); else if (j === prev && prev >= 0) s.classList.add('out'); });
      items.forEach(function (it, j) { it.classList.toggle('on', j === i); var b = it.querySelector('.flow__row'); if (b) b.setAttribute('aria-expanded', j === i ? 'true' : 'false'); });
      paint(i);
    }
    var ticking = false;
    function update() {
      ticking = false;
      if (!pin()) {
        // mobile: pack is sticky — activate the last item whose top has scrolled up past
        // a fixed line just below the sticky pack (use stable offsetHeight, not the live
        // rect, which goes negative once the pack unsticks at the section's end).
        var stg = sec.querySelector('.flow__stage');
        var ref = 56 + (stg ? stg.offsetHeight : 240) + 20;
        var mi = 0, best = Infinity;
        items.forEach(function (it, j) {
          var r = it.getBoundingClientRect(), c = r.top + r.height / 2, d = Math.abs(c - ref);
          if (d < best) { best = d; mi = j; }
        });
        go(mi);
        if (bar) bar.style.transform = 'translateX(' + (mi * 100) + '%)';
        return;
      }
      var total = sec.offsetHeight - window.innerHeight;
      if (total <= 0) { go(0); return; }
      var prog = clamp(-sec.getBoundingClientRect().top / total, 0, 1);
      var idx = prog < 1 / 3 ? 0 : prog < 2 / 3 ? 1 : 2;
      go(idx);
      if (bar) bar.style.transform = 'translateX(' + (prog * (n - 1) * 100) + '%)';
    }
    rows.forEach(function (r) {
      r.addEventListener('click', function () {
        var i = +r.dataset.flow;
        if (!pin()) { go(i); return; }
        var se = document.scrollingElement || document.documentElement;
        var total = sec.offsetHeight - window.innerHeight;
        var top = se.scrollTop + sec.getBoundingClientRect().top + total * ((i + 0.5) / n);
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    window.addEventListener('resize', update);
    go(0); update();
  });

  // ---- Horizontal video carousels with arrow nav ----
  document.querySelectorAll('[data-vcarousel]').forEach(function (car) {
    var track = car.querySelector('[data-vtrack]'), prev = car.querySelector('[data-vprev]'), next = car.querySelector('[data-vnext]');
    if (!track) return;
    var step = function () { var card = track.querySelector('.vcard'); return card ? card.offsetWidth + 14 : 220; };
    var upd = function () {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 1.5, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 1.5, behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  // ---- Founder film modal ----
  (function () {
    var triggers = document.querySelectorAll('[data-film]');
    if (!triggers.length) return;
    var modal = document.querySelector('[data-vmodal]');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'vmodal'; modal.setAttribute('data-vmodal', '');
      modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Video');
      modal.innerHTML = '<button class="vmodal__close" data-vclose aria-label="Close video">✕</button><div class="vmodal__inner" data-vinner></div>';
      document.body.appendChild(modal);
    }
    var inner = modal.querySelector('[data-vinner]');
    var openFilm = function (src, poster) {
      inner.innerHTML = src
        ? '<video src="' + src + '" controls autoplay playsinline poster="' + poster + '"></video>'
        : '<img src="' + poster + '" alt="" /><div class="founderfilm__cap" style="left:18px;bottom:16px">Film coming soon — Jonathan Carp, MD</div>';
      modal.classList.add('is-open');
    };
    var closeFilm = function () { modal.classList.remove('is-open'); inner.innerHTML = ''; };
    triggers.forEach(function (f) {
      f.addEventListener('click', function () {
        var src = f.dataset.src, poster = f.dataset.poster;
        if (!src) { openFilm('', poster); return; } // poster-only until the real cut is added
        fetch(src, { method: 'HEAD' }).then(function (r) { openFilm(r.ok ? src : '', poster); }).catch(function () { openFilm('', poster); });
      });
    });
    modal.querySelector('[data-vclose]').addEventListener('click', closeFilm);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeFilm(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilm(); });
  })();

  // (email-capture popup removed — handled by a dedicated plugin)
})();

/* rotating announcement bar — one bar, alternates between the two messages */
(function () {
  var host = document.querySelector('[data-announce]'); if (!host) return;
  var msg = host.querySelector('.announce__msg'); if (!msg) return;
  /* messages come from the section schema (data-messages JSON) when present; the literal
     default below is the exact source copy so parity holds with zero editor input */
  var MSGS = ['Free shipping on every order', 'Curated by Jonathan Carp, MD'];
  try { var dm = host.getAttribute('data-messages'); if (dm) { var parsed = JSON.parse(dm); if (parsed && parsed.length) MSGS = parsed; } } catch (e) {}
  if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var i = 0;
  setInterval(function () {
    host.classList.add('is-fading');
    setTimeout(function () { i = (i + 1) % MSGS.length; msg.textContent = MSGS[i]; host.classList.remove('is-fading'); }, 450);
  }, 4200);
})();

/* Newsletter forms → Klaviyo (client subscribe API; audit: no more fake "Subscribed ✓") */
(function () {
  var COMPANY = 'KwatnF', LIST = 'WXX3Ef';
  document.querySelectorAll('form[data-klaviyo]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]'), btn = form.querySelector('button');
      var email = (input.value || '').trim(); if (!email) return;
      var ok = form.getAttribute('data-success') || 'Subscribed ✓';
      btn.disabled = true; btn.textContent = '…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: LIST } } } } })
      }).then(function (r) {
        btn.textContent = r.ok || r.status === 202 ? ok : 'Try again';
        if (r.ok || r.status === 202) input.value = '';
      }).catch(function () { btn.textContent = 'Try again'; })
        .finally(function () { btn.disabled = false; setTimeout(function () { btn.textContent = form.getAttribute('data-label') || 'Sign up'; }, 3500); });
    });
  });
})();

/* ==== Wave 3-lite a11y module (ports 1:1 into the Shopify theme) ==== */
(function () {
  /* 1. Skip link */
  var main = document.querySelector('main');
  if (main) {
    if (!main.id) main.id = 'main';
    var skip = document.createElement('a');
    skip.href = '#' + main.id; skip.className = 'skip-link'; skip.textContent = 'Skip to content';
    document.body.insertBefore(skip, document.body.firstChild);
  }

  /* 2. Shared focus trap for every dialog (menusheet, cart, search, askbot panel) */
  var DIALOGS = ['.menusheet', '.cart', '.search', '.askbot', '.vmodal'];
  var lastFocus = null;
  function focusables(root) {
    return [].slice.call(root.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  DIALOGS.forEach(function (sel) {
    var el = document.querySelector(sel); if (!el) return;
    new MutationObserver(function () {
      var open = el.classList.contains('is-open');
      if (open) {
        lastFocus = document.activeElement;
        var f = focusables(el); if (f.length) setTimeout(function () { f[0].focus(); }, 60);
      } else if (lastFocus && document.activeElement && el.contains(document.activeElement)) {
        lastFocus.focus();
      }
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var open = null;
    DIALOGS.some(function (sel) { var el = document.querySelector(sel); if (el && el.classList.contains('is-open')) { open = el; return true; } return false; });
    if (!open) return;
    var f = focusables(open); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!open.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  /* 3. aria-live announcements: cart + search + askbot */
  var live = document.createElement('div');
  live.className = 'sr-only'; live.setAttribute('aria-live', 'polite'); live.setAttribute('role', 'status');
  document.body.appendChild(live);
  window.MNAnnounce = function (msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50); };
  if (window.MNCart && window.MNCart.add) {
    var origAdd = window.MNCart.add.bind(window.MNCart);
    window.MNCart.add = function (item) {
      origAdd(item);
      var items = (window.MNCart.items && window.MNCart.items()) || [];
      var count = items.reduce(function (s, i) { return s + i.qty; }, 0);
      window.MNAnnounce('Added ' + item.name + ' to cart. Cart now has ' + count + ' item' + (count === 1 ? '' : 's') + '.');
    };
  }
  var sr = document.querySelector('.search [data-sr]'); if (sr) sr.setAttribute('aria-live', 'polite');
  var ab = document.querySelector('.askbot__body'); if (ab) { ab.setAttribute('role', 'log'); ab.setAttribute('aria-live', 'polite'); }

  /* 4. Founder film: keyboard playable */
  var film = document.querySelector('[data-film][role="button"]');
  if (film) film.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); film.click(); } });
})();

/* Yotpo real-data stars on cards (from data/yotpo.json cache) */
(function () {
  var els = document.querySelectorAll('[data-yotpo-stars]');
  if (!els.length) return;
  /* Shopify: the cache lives at the data-yotpo.json theme asset (URL injected via MNRoutes);
     the source-relative path is kept as fallback for the static site. */
  var yurl = (window.MNRoutes && window.MNRoutes.yotpoData) || 'data/yotpo.json';
  fetch(yurl).then(function (r) { return r.json(); }).then(function (Y) {
    els.forEach(function (el) {
      var y = Y[el.getAttribute('data-yotpo-stars')]; if (!y) return;
      el.textContent = '★ ' + y.avg.toFixed(1) + ' (' + y.total.toLocaleString() + ' reviews)' + (el.dataset.price ? ' · ' + el.dataset.price : '');
    });
  }).catch(function () {});
})();
